
import * as cloudflareRuntime$GbCRNKJaOp from '/opt/buildhome/repo/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflare",
  "domains": [
    "beyraha.s3.eu-central-1.amazonaws.com",
    "pakpazar.com",
    "www.pakpazar.com"
  ],
  "alias": {
    "/cl": "cdn-cgi/imagedelivery/st1uxlphT2vI8j_75ka47g"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$GbCRNKJaOp, defaults: {"baseURL":"https://www.beyraha.com"} }
}
        